


























import {
  Vue, Component, Emit, Prop,
} from 'vue-property-decorator';

@Component
export default class BaseCarousel extends Vue {
  @Prop({ type: String })
  readonly defaultSelected!: string;

  @Prop({ type: Array, required: true })
  readonly items!: [];

  @Prop({ type: String })
  readonly activeClass!: '';

  public selectedItem: string = this.defaultSelected ? this.defaultSelected : '';

  @Emit('onItemClick')
  onItemClick(item: string): string {
    this.selectedItem = item;
    const doc = document.getElementById(`item-${item}`);
    if (doc) {
      doc.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
    return item;
  }
}
